import PropTypes from "prop-types"
import React from "react"

import ClickablePhoneNumber from "src/components/ClickablePhoneNumber"

const PhoneDetails = ({ label, data, phone }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-col space-y-2">
        <span className="font-semibold">{label}</span>
        <div className="text-gray-600">
          <ClickablePhoneNumber phone={phone} displayPhone={data} />
        </div>
      </div>
    </div>
  )
}

PhoneDetails.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.string,
  phone: PropTypes.string,
}

export default PhoneDetails
